import type {
  ReportAmbulanceListQueryParams,
  ReportAmbulanceListResponse,
  ReportDetailResponse,
  ReportDispatchRequestBody,
  ReportDispatchResponse,
} from '@/domains/traffic-monitoring/types/ambulance-dispatch.types';
import { request } from '@/shared/utils/request';

const buildQuery = (params?: Record<string, unknown>): string => {
  const search = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        search.append(key, String(value));
      }
    });
  }
  return search.toString();
};

export const ambulanceDispatchApi = {
  // GET /api/dsh/ambulance-report/{report_id}/ambulance -> { report, total_count, page, page_size, items[] }
  // Live route is registered under the "/ambulance-report" namespace - the spec
  // doc says "/report/{report_id}/ambulance", but the code (__init__.py) wins.
  getReportAmbulanceList: async (
    reportId: number,
    params?: ReportAmbulanceListQueryParams
  ): Promise<ReportAmbulanceListResponse> => {
    const qs = buildQuery(params as Record<string, unknown> | undefined);
    return request.get<ReportAmbulanceListResponse>(
      qs
        ? `/ambulance-report/${reportId}/ambulance?${qs}`
        : `/ambulance-report/${reportId}/ambulance`
    );
  },

  // GET /api/dsh/report/{report_id} -> { report, patients[], ambulance_reports[], counts }
  getReportDetail: async (reportId: number): Promise<ReportDetailResponse> => {
    return request.get<ReportDetailResponse>(`/report/${reportId}`);
  },

  // POST /api/dsh/report/dispatch -> { report_id, updated_fields[], dispatch_requests[] }
  postReportDispatch: async (body: ReportDispatchRequestBody): Promise<ReportDispatchResponse> => {
    return request.post<ReportDispatchResponse>('/report/dispatch', body);
  },
};
